var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hands-helping",
    "data-name": "Icon awesome-hands-helping",
    d: "M19.062,9.376H13.124v2.735c0,1.939-1.262,3.516-2.812,3.516S7.5,14.05,7.5,12.111V6.173l-2.535,1.9a3.34,3.34,0,0,0-1.215,2.676v2.31L.624,15.319a1.786,1.786,0,0,0-.457,2.134l3.125,6.768A1.125,1.125,0,0,0,5,24.793l4.039-2.915h5.336c1.379,0,2.5-1.4,2.5-3.125H17.5a1.431,1.431,0,0,0,1.25-1.563V14.064h.312A1.072,1.072,0,0,0,20,12.892V10.548A1.072,1.072,0,0,0,19.062,9.376Zm5.77-1.826L21.706.782A1.125,1.125,0,0,0,20,.21L15.96,3.126H11.968a2.162,2.162,0,0,0-1.324.474L9.335,4.62a1.672,1.672,0,0,0-.586,1.323v6.168a1.79,1.79,0,0,0,1.562,1.953,1.79,1.79,0,0,0,1.562-1.953v-4.3h7.187a2.509,2.509,0,0,1,2.187,2.735V11.94l3.125-2.256a1.793,1.793,0,0,0,.457-2.134Z",
    transform: "translate(0.002 -0.002)",
    fill: "#64c2c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultoria);
export default __webpack_public_path__ + "static/media/consultoria.ce9982fb776fbee661f72dfa18ff63b7.svg";
export { ForwardRef as ReactComponent };